module.exports = __webpack_public_path__ + "dash_20_app_assets/img/SingleAnswer.4e6b0447.png";